import { REGEX_CONSTANT } from "../../../constant/regexConstant";

export const validDepot = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "depot_name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 100) {
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_description":
      if (data?.length > 256) {
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_email":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else if (!REGEX_CONSTANT.EMAIL.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_phone":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      }else if (data?.length > 12 || data?.length < 10) {
        error[namespace] = translate("Field cannot be less than 9 and more than 12", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } 
       else {
        error[namespace] = null;
      }
      break;
    case "country_code_fax":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else if (!REGEX_CONSTANT.FAX.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_fax":
      if (data?.length > 1 && !REGEX_CONSTANT.FAX.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "max_range":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_country":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_province":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_district":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_sub_district":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_urban_village":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else {
        error[namespace] = null;
      }
      break;

    case "depot_postal_code":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else {
        error[namespace] = null;
      }
      break;

    case "depot_address_1":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else if (data?.length > 100 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_address_2":
      if (data?.length > 100) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_address_3":
      if (data?.length > 100) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_neighbourhood":
      if (data?.length > 3) {
        error[namespace] = translate("Field cannot be less than 1 and more than 3", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_hamlet":
      if (data?.length > 3) {
        error[namespace] = translate("Field cannot be less than 1 and more than 3", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_longitude":
      if (!REGEX_CONSTANT.LNG_LAT.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 30 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 30", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "depot_latitude":
      if (!REGEX_CONSTANT.LNG_LAT.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 30 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 30", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "length_uom":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "weight_uom":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "volume_uom":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "temperature_uom":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "position_pic":
      if (data?.length > 100) {
        error[namespace] = translate("Field cannot be less than 1 and more than 30", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "first_name_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 50 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 50", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "last_name_pic":
      if (data?.length > 50) {
        error[namespace] = translate("Field cannot be less than 1 and more than 50", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "nik_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 20) {
        error[namespace] = translate("Field cannot be less than 1 and more than 20", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.NIK.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "birth_place_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data?.length > 50) {
        error[namespace] = translate("Field cannot be less than 1 and more than 50", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "birth_date_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;

    case "phone_number_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else if (data?.length > 12 || data?.length < 10) {
        error[namespace] = translate("Field cannot be less than 9 and more than 12", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "npwp_pic":
      if ((data !== "" && data !== undefined) && !REGEX_CONSTANT.NPWP.test(data)) {
        error[namespace] = translate("Please type your NPWP number correctly. Ensure the 7th–10th digit number is correct according to your date and month of birth.", {
          field: translate("Role ID"),
        });
      } else if ((data !== "" && data !== undefined) && (data?.length > 16 || data?.length < 15)) {
        error[namespace] = translate("Field cannot be less than 15 and more than 16", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "email_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.EMAIL.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;

    case "country_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "island_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "district_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "sub_district_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "urban_village_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "address_pic":
      if (data?.length > 100) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "neighbourhood_pic":
      if (data?.length > 3) {
        error[namespace] = translate("Field cannot be less than 1 and more than 3", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data !== null && data !== undefined && !REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "hamlet_pic":
      if (data?.length > 3) {
        error[namespace] = translate("Field cannot be less than 1 and more than 3", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data !== null && data !== undefined && !REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "postal_code_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "province_pic":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    default:
      break;
  }
  return error;
};
